import { Backdrop, Portal } from '@mui/material';
import { MovexLoadingIcon } from '@osp-silver/movex-ui';

// Portaled to <body> so parent layout styles can't offset the fixed overlay —
// e.g. MovexLoginPageLayout's Stack spacing adds margin-top to its children.
const Loading = () => {
  return (
    <Portal>
      <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.modal }}>
        <MovexLoadingIcon size={32} />
      </Backdrop>
    </Portal>
  );
};

export default Loading;
